export default "__VITE_ASSET__yepz_wby__"